import "data-layer-helper/dist/data-layer-helper";
import { getDataLayer } from "../../helper/getDatalayer.js";
import { getReferrer } from "../data-layer/auto-tracking/basedata/referrer.js";
import { setProductAttribution, clearProductAttribution } from "./productAttribution";

const dataLayer = getDataLayer();
clearAttributionOnExternalEntry();
observe(dataLayer);

function clearAttributionOnExternalEntry() {
	if (getReferrer() !== null) {
		clearProductAttribution();
	}
}

function observe(dataLayer) {
	return new DataLayerHelper(dataLayer, listener, true);
}

export async function listener(model, message) {
	const eventName = getEventName(message);
	switch (eventName) {
		case "select_item":
			setProductAttribution(model, message);
			break;
		case "product-attribution-bulk":
			setProductAttribution(model, message);
			break;
		case "add_to_cart": {
			const itemListContext = getItemListContext(message);
			if (itemListContext === "product-list") {
				setProductAttribution(model, message);
			}
			break;
		}
		default:
			break;
	}
}

export function getEventName(message) {
	return message?.event;
}

export function getItemListContext(message) {
	return message?.ecommerce?.item_list_context;
}